import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { C, HEADSHOT } from "../data/content";
import { ParticleHero } from "./ParticleHero";
import { RegistrationForm } from "./RegistrationForm";

export const Hero = ({ attribution }) => {
  const ref = useRef(null);

  useEffect(() => {
    const lines = ref.current.querySelectorAll(".mask-line > span");
    gsap.to(lines, { y: 0, duration: 1, ease: "power4.out", stagger: 0.12, delay: 0.35 });
    gsap.fromTo(ref.current.querySelectorAll(".hero-fade"),
      { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: 0.9, stagger: 0.08, delay: 0.9, ease: "power2.out" });
  }, []);

  return (
    <section ref={ref} className="relative min-h-screen grid-bg overflow-hidden" data-testid="hero-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-32 pb-16 grid lg:grid-cols-2 gap-12 items-center min-h-screen">
        <div className="relative z-10">
          <p className="mono text-[10px] tracking-[0.22em] text-[var(--accent)] mb-6 hero-fade" data-testid="hero-eyebrow">{C.eyebrow}</p>
          <p className="mono text-[10px] text-white/30 mb-4 hero-fade" data-testid="hero-date-line">{C.dateLine}</p>
          <h1 className="h1-display text-[clamp(40px,5.6vw,76px)]" data-testid="hero-h1">
            <span className="mask-line"><span>{C.h1.line1}</span></span>
            <span className="mask-line"><span className="text-[var(--accent)]">{C.h1.line2}</span></span>
            <span className="mask-line"><span className="opacity-60 text-[62%] leading-snug">{C.h1.line3}</span></span>
          </h1>
          <p className="text-[15px] text-white/55 leading-relaxed mt-7 max-w-[540px] hero-fade" data-testid="hero-subheadline">
            The free live call that shows <span className="text-[var(--accent)]">VA-eligible buyers</span> in FL, TX &amp; PA their exact qualification number and a real, funded <span className="text-[var(--accent)]">pre-approval path</span> — without a slow, generic online application.
          </p>
          <blockquote className="border-l-2 pl-5 italic text-[14px] text-white/60 mt-7 max-w-[500px] hero-fade" style={{ borderColor: "var(--accent)" }} data-testid="hero-blockquote">
            {C.blockquote}
          </blockquote>
          <div className="mt-8 hero-fade">
            <button className="btn-accent cta" data-testid="hero-cta-button"
              onClick={() => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" })}>
              {C.ctaLabel}
            </button>
            <p className="text-[11px] text-white/25 mt-3">{C.ctaSub}</p>
          </div>
          <div className="flex items-center gap-4 mt-12 hero-fade" data-testid="hero-host-module">
            <img src={HEADSHOT} alt="Darren Gussick" className="w-[46px] h-[46px] rounded-full object-cover border-2" style={{ borderColor: "var(--accent)" }} />
            <div>
              <p className="text-sm font-bold">{C.hostName}</p>
              <p className="text-[11px] text-white/40">{C.hostCompany} · NMLS# {C.hostNmls}</p>
            </div>
          </div>
        </div>
        <div className="relative">
          <div className="absolute -inset-16 hidden lg:block"><ParticleHero /></div>
          <div className="relative z-10 max-w-[460px] lg:ml-auto hero-fade">
            <RegistrationForm attribution={attribution} idPrefix="hero" />
          </div>
        </div>
      </div>
    </section>
  );
};
